export const URL = "https://api.clerkhound.com";
export const S3_BASE_URL = "https://app.clerkhound.com";
export const MERCHANT_MANAGER_URL = "https://app.maast.com";
export const HOW_TO_VIDEOS_URL = "https://clerkhound.com/videos/";
export const FAQ_URL = "https://faq.clerkhound.com/";
export const WEBSOCKET = "wss://ws.clerkhound.com";
export const ROSTERHOUND_URL = "https://rosterhound.vercel.app";
